import { TireRackItemI } from "../../types/store";

export const updateTireRack = (updatedTireRack: TireRackItemI, existingTireRacks: TireRackItemI[]): TireRackItemI[] => {
    return existingTireRacks.map((tireRack) => (tireRack.id === updatedTireRack.id ? updatedTireRack : tireRack));
};
